import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/mail.svg'
import _imports_1 from '../assets/img/phone.svg'
import _imports_2 from '../assets/img/map-pin.svg'


const _hoisted_1 = { class: "contact row justify-content-center" }
const _hoisted_2 = { class: "text-center col-md-8" }
const _hoisted_3 = { class: "contact__links" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Mail us"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Call us"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Route"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.blok.text), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        href: `mailto:${_ctx.blok.email.url}`,
        target: "_blank",
        rel: "noopener nofollow"
      }, _hoisted_6, 8, _hoisted_4),
      _createElementVNode("a", {
        href: `tel:${_ctx.blok.phone.url}`,
        target: "_blank",
        rel: "noopener nofollow"
      }, _hoisted_9, 8, _hoisted_7),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blok.socials, (item) => {
        return (_openBlock(), _createElementBlock("a", {
          key: item._uid,
          href: item.link.url,
          target: "_blank",
          rel: "noopener nofollow"
        }, [
          _createElementVNode("img", {
            src: item.icon.filename,
            alt: "Visit our socials"
          }, null, 8, _hoisted_11)
        ], 8, _hoisted_10))
      }), 128)),
      _createElementVNode("a", {
        href: _ctx.blok.route.url,
        target: "_blank",
        rel: "noopener nofollow"
      }, _hoisted_14, 8, _hoisted_12)
    ])
  ]))
}